import { groupQueryKeys } from "../../../types/Groups";
import { slideQueryKeys } from "../../../types/Slides";
import { getActiveService } from "../../../utilities/activeService";
import { buildSlides } from "./buildSlides";
import { createSlide } from "./createSlide";
import { defaultGroups } from "./groups";
import { missingSlide } from "../slides/missingSlide";
import { querySelectorURL } from "../../cpcoc/querySelectorURL";
const customSlidesQuery = querySelectorURL("custom");
const customSlides = typeof customSlidesQuery === "string" &&
    JSON.parse(decodeURIComponent(customSlidesQuery));
export function getSlides() {
    var _a;
    const queryGroup = querySelectorURL("group");
    const querySlides = querySelectorURL("slides");
    let count = 0;
    // custom slides
    if (customSlides && customSlides.length) {
        for (let i = 0, l = customSlides.length; i < l; i++) {
            count++;
            createSlide(customSlides[i], "custom-slide-" + i);
        }
    }
    // set an initial group
    if (typeof queryGroup === "string") {
        const queryGroupIndex = groupQueryKeys[queryGroup];
        let groupSlides = (_a = getActiveService()) === null || _a === void 0 ? void 0 : _a.slideGroups[queryGroupIndex];
        if (!(groupSlides === null || groupSlides === void 0 ? void 0 : groupSlides.length)) {
            // TODO: are defaults necessary?
            groupSlides = defaultGroups[queryGroupIndex]; // fallback to defaults if not defined
        }
        if (groupSlides === null || groupSlides === void 0 ? void 0 : groupSlides.length) {
            count += groupSlides.length;
            buildSlides(groupSlides);
        }
    }
    // add any additional slides
    if (typeof querySlides === "string") {
        const slideKeys = querySlides.split(/,[ ]?/g).map((slideName) => slideQueryKeys[slideName]);
        count += slideKeys.length;
        buildSlides(slideKeys);
    }
    // fallback slide
    if (count === 0) {
        missingSlide();
    }
}
